import { useEffect, useState } from "react";
import { DocumentModel } from "../../../model/DocumentModel";
import { useDisclosure } from "@mantine/hooks";
import { useForm } from "@mantine/form";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import { MessageResponse } from "../../../model/MessageResponse";
import {
    Box,
    LoadingOverlay,
    Grid,
    TextInput,
    Checkbox,
    Button,
    Group,
    Textarea,
} from "@mantine/core";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositorySign } from "../../../_base/_const/_constVar";
const DocTypeEditView = ({ id, onClose }: DocTypeEditViewProps) => {
    const [entity, setEntity] = useState<DocumentModel>({
        id: 0,
        code: null,
        name: null,
        description: null,
        active: true,
        createBy: null,
        lastUpdateBy: null,
        createDate: null,
        lastUpdateDate: null,
    });
    const [visible, { close, open }] = useDisclosure(false);
    const [enable, setEnable] = useState(false);

    const form = useForm<DocumentModel>({
        mode: "uncontrolled",
        validateInputOnChange: true,
        initialValues: {
            ...entity,
        },
        transformValues: (values) => ({
            ...values,
        }),
        validate: {
            code: (value) => {
                if (!value) {
                    return "Vui lòng nhập mã loại tài liệu!";
                }
                return null;
            },
            name: (value) => {
                if (!value) {
                    return "Vui lòng nhập tên loại tài liệu!";
                }
                return null;
            },
        },
    });

    const handleGetDataDocType = async () => {
        let url = `https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblDocType/update?id=${id}`;
        const response = await repositorySign.get<
            MessageResponse<DocumentModel>
        >(url);
        if (!response?.success) {
            NotificationExtension.Fails("Bạn không có quyền sửa!!!");
            modals.closeAll();
            return;
        }
        if (response?.success) {
            const dataVendor = response?.data;
            if (dataVendor != null) {
                setEntity(dataVendor);
                form.setValues(dataVendor);
                form.resetDirty(dataVendor);
            }
            close();
        } else {
            modals.closeAll();
        }
    };

    const handleEditPartner = async (payload: DocumentModel) => {
        open();

        let url =
            "https://apis-pos-dev.hacom.vn/api-sign/api/v1/TblDocType/update";

        const response = await repositorySign.post<MessageResponse<boolean>>(
            url,
            payload
        );

        if (response?.success) {
            onClose((prev: any) => !prev);
            NotificationExtension.Success("Cập nhật thành công!!!");
            modals.closeAll();
        } else {
            NotificationExtension.Fails("Sửa thất bại !");
        }

        modals.closeAll();
        close();
    };

    useEffect(() => {
        if (id) {
            handleGetDataDocType();
        }
    }, [id]);

    useEffect(() => {
        if (form.isDirty()) {
            setEnable(true);
        }

        setEnable(false);
    }, [form]);

    return (
        <Box
            component="form"
            onSubmit={form.onSubmit((e: DocumentModel) => {
                handleEditPartner(e);
            })}
            mx="auto"
            w={{ base: "250px", md: "300px", lg: "400px" }}
            style={{ position: "relative" }}
        >
            <LoadingOverlay
                visible={visible}
                zIndex={1000}
                overlayProps={{ radius: "sm", blur: 2 }}
            />
            <Grid>
                <Grid.Col span={12}>
                    <TextInput
                        label="Mã loại tài liệu"
                        placeholder="Nhập mã loại tài liệu"
                        {...form.getInputProps("code")}
                    />
                </Grid.Col>

                <Grid.Col span={12}>
                    <TextInput
                        label="Tên loại tài liệu"
                        placeholder="Nhập tên loại tài liệu"
                        {...form.getInputProps("name")}
                    />
                </Grid.Col>

                <Grid.Col span={12}>
                    <Textarea
                        label="Mô tả"
                        placeholder="Mô tả loại tài liệu"
                        {...form.getInputProps("description")}
                    />
                </Grid.Col>

                <Grid.Col span={12}>
                    <Checkbox
                        label="Sử dụng"
                        checked={form.values.active}
                        {...form.getInputProps("active")}
                    ></Checkbox>
                </Grid.Col>
            </Grid>
            <Grid>
                <Grid.Col
                    span={12}
                    display={"flex"}
                    style={{ justifyContent: "flex-end", gap: "40px" }}
                >
                    <Button
                        type="button"
                        color="gray"
                        loading={visible}
                        onClick={() => {
                            modals.closeAll();
                        }}
                        leftSection={
                            !visible ? <IconWindow size={18} /> : undefined
                        }
                    >
                        Đóng
                    </Button>
                    <Button
                        type="submit"
                        color="blue"
                        loading={visible}
                        leftSection={
                            !visible ? <IconCheck size={18} /> : undefined
                        }
                    >
                        Lưu
                    </Button>
                </Grid.Col>
            </Grid>
        </Box>
    );
};
type DocTypeEditViewProps = {
    id: number | string;
    onClose: any;
};
export default DocTypeEditView;
